import { render, staticRenderFns } from "./CollapseRow.vue?vue&type=template&id=4063e1bc&scoped=true&"
import script from "./CollapseRow.vue?vue&type=script&lang=ts&"
export * from "./CollapseRow.vue?vue&type=script&lang=ts&"
import style0 from "./CollapseRow.vue?vue&type=style&index=0&id=4063e1bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4063e1bc",
  null
  
)

export default component.exports